/* tslint:disable */
/* eslint-disable */
export enum IntegrationStatus {
  AuthRequired = 'AuthRequired',
  Ready = 'Ready'
}
